import React, { useEffect, useState } from "react";
import auth from '../../../service/Auth';
import {asperashares} from '../../../service/apis';
import PopupMessage from "../components/PopupMessage";
import { Redirect } from "react-router-dom";
import { downloadCSV }  from '../../../service/CsvButton';
import TableView from "../components/TableView";

const config = window.config;

const headers = [
    { label: "Aspera Folder" , key: "SharesFolder",tooltip: "Red Iris Aspera Shares Directory."},
    { label: "User" , key: "User",tooltip: "User of the Red Iris Aspera Shares Directory." },
    { label: "User Groups" , key: "UserGroups" ,tooltip: "Groups associated to the user."},
    { label: "Files In Aspera Folder" , key: "FilesInAsperaFolder",tooltip: "Total number of files found at the Red Iris Aspera Shares Directory." },
    { label: "Experiments In Aspera Folder" , key: "ExperimentsInAsperaFolder", tooltip: "Experiments having files submitted at Red Iris."  }
];

const AsperaSummary = (props) =>{

    const [data, setData] = useState({});
    const [errors, setErrors] = useState("");
    const [loading, setLoading] =  useState(true);
    const [type, setType] = useState("");
    const [share, setShare] = useState("");
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    
    const fetchData = async () => { 
        await asperashares(auth.getToken(),config.api_endpoint)
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setData(data);
            setLoading(false);
        })
    }
    
    useEffect(() => {
        // 1. Logging Check
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setErrors("User does not have admin permissions.");
        }
        else if (props.location.data === undefined) {
            // 1.1 Update loadData Status
            fetchData();
        }
        else {
            // 1.2 If AsperaSummary is called from and aspera infor view then is not needed to reload data from API
            setData(props.location.data);
            setLoading(false);
        }
    },[])
    
    const updateColumns = () => {
        let cols = []
        for (let header of headers) {
            let col = {};
            col["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
            col["accessor"] = header.key;
            col["minWidth"] = 220;
            cols.push(col);
        }
        setColumns(cols);
    }
    
    const updateRows = () => {
        let tableRows = [];
        for (let share in data) {
            let rowTable = {};
            //1. Loop Headers
            for (let column of columns){
                switch (column.accessor) {
                    case "SharesFolder":
                        rowTable[column.accessor] = share;
                        break;
                    case "User":
                        rowTable[column.accessor] = data[share]["aspera_user"];
                        break;
                    case "UserGroups":
                        rowTable[column.accessor] = data[share]["group"].join(" ");
                        break;
                    case "FilesInAsperaFolder":
                        rowTable[column.accessor] = data[share]["total_files"];
                        break;
                    case "ExperimentsInAsperaFolder":
                        rowTable[column.accessor] = data[share]["total_experiments"];
                        break;
              }
            }
            //2. Add row to data
            tableRows.push(rowTable);
        }
        // 3. Update Rows
        setRows(tableRows);
    }
    
    useEffect(() => {
        // 1. Update Table Columns
        updateColumns(); 
        // 2. Update Rows with the updated data memeber
        updateRows();
    },[data])
    
    const onRowClick = (state, rowInfo, column, instance) => {
        // On Row Click Handler
        return {
            onClick: e => {
                /*1.If row is Experiment ID then Route to Experiment Information*/
                if(rowInfo && (column.id === "FilesInAsperaFolder" || column.id === "ExperimentsInAsperaFolder")){
                    setShare(rowInfo.original.SharesFolder);
                    setType(column.id);
                }
            },
            style: {
                cursor: 'pointer'
            },
        }
    };
      
    const getCsvData = (events) => {
      // Handler to get CSV Data
      let today = new Date().toISOString().slice(0, 10);
      downloadCSV(rows,headers,`${today}_aspera_summary.csv`);
    }
    
    /*Show popup in case an error with the loggin occurs*/
    if (errors !== "") {
        return <PopupMessage title={"Logging error!"} message={errors} href={"#/admin"} />;
    }
    else if(type === "FilesInAsperaFolder") {
        return <Redirect to={{pathname:'/admin/asperainfo',share:share,apiInfo:data,type:type}}/>;
    }
    else if(type === "ExperimentsInAsperaFolder") {
        return <Redirect to={{pathname:'/admin/asperaexperimentsinfo',share:share,apiInfo:data,type:type}}/>;
    }
    else {
        return (
            <TableView 
                title = {"Red Iris Aspera Shares Status"}
                href = {"#/admin"}
                getCsvData = {getCsvData}
                rows = {rows}
                columns = {columns}
                onRowClick = {onRowClick}
                height = {700}
                loading = {loading}
            />
        );
    }    
} 
 
export default AsperaSummary;